import React, { Suspense } from 'react';

import '~/locales';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import AppProvider from './hooks';
import Routes from './routes';

import GlobalStyles from './styles/global';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AppProvider>
        {/* O Suspense serve para o reactI18next */}
        <Suspense fallback={<p>Carregando...</p>}>
          <Routes />
          <GlobalStyles />
          <ToastContainer autoClose={3000} />
        </Suspense>
      </AppProvider>
    </BrowserRouter>
  );
};

export default App;
